var map = {
	"./application-device.svg": 10663,
	"./arrow.svg": 10141,
	"./bag-all.svg": 29170,
	"./bag-glass.svg": 67395,
	"./bag-metal.svg": 83378,
	"./bag-mix.svg": 7729,
	"./bag-plastic.svg": 59063,
	"./bank.svg": 12580,
	"./blik.svg": 24564,
	"./cash-device.svg": 27550,
	"./cash.svg": 92687,
	"./collections.svg": 9969,
	"./credit-card.svg": 76084,
	"./europlatform.svg": 19252,
	"./glass-bag.svg": 76775,
	"./glass.svg": 14562,
	"./kaucyjni.svg": 43768,
	"./location-mapping.svg": 15966,
	"./mastercard.svg": 36538,
	"./metal-bag.svg": 53774,
	"./metal.svg": 883,
	"./mix-bag.svg": 25073,
	"./mix.svg": 24236,
	"./mobile.svg": 66676,
	"./operators.svg": 15089,
	"./plastic-bag-full.svg": 14407,
	"./plastic-bag.svg": 35919,
	"./plastic.svg": 78458,
	"./przelewy24.svg": 62532,
	"./reports.svg": 43179,
	"./rvm-device.svg": 9798,
	"./settings.svg": 48181,
	"./stores.svg": 36496,
	"./tutorial-mobile.svg": 49143,
	"./tutorial.svg": 4196,
	"./visa.svg": 20605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41118;